module.exports = __webpack_public_path__ + "img/SOKAL-SRS-120921-Tucson-Lifestyle.ddfb387b.jpeg";